import { useWire } from "~/wire";

export const useGateActionByChatPermission = <T extends Array<unknown>, U>(
  action: (...args: T) => U,
  onCancel?: () => void,
) => {
  const wire = useWire();

  const wrappedAction = (...args: T): U | undefined => {
    const canCreateChat = wire.grants.canCreate("cp.chats");
    if (!canCreateChat) {
      wire.ui.chatPermissionsGate.openModal();
      onCancel?.();
      return;
    }
    return action(...args);
  };

  return wrappedAction;
};
